export class TextDependencyBehaviour {
  constructor(config, dependency) {
    this.type = 'text'
    this.dependency = dependency
    this.config = config
  }

  getText() {
    return this.config.from[this._valueFromTrackingField()]
  }

  _valueFromTrackingField() {
    const input = this.dependency.trackingFieldInput
    return input ? input.value : null
  }
}
